// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.share-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.dark .share-modal {
  background: #1f2937;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.dark .modal-header {
  border-bottom: 1px solid #374151;
}

.modal-header h2 {
  margin: 0;
  color: #333;
  font-size: 1.5rem;
}

.dark .modal-header h2 {
  color: #f3f4f6;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #f5f5f5;
  color: #333;
}

.dark .close-btn {
  color: #9ca3af;
}

.dark .close-btn:hover {
  background: #374151;
  color: #f3f4f6;
}

.modal-body {
  padding: 1.5rem;
}

.share-section {
  margin-bottom: 2rem;
}

.share-section h3 {
  margin: 0 0 1rem 0;
  color: #555;
  font-size: 1.1rem;
}

.dark .share-section h3 {
  color: #d1d5db;
}

.url-container {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.url-container.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.url-input {
  flex: 1 1;
  padding: 0.75rem;
  border: 2px solid #e5e7eb;
  border-radius: 6px;
  font-size: 0.95rem;
  font-family: monospace;
  background: #f9fafb;
}

.dark .url-input {
  background: #111827;
  border-color: #374151;
  color: #f3f4f6;
}

.copy-btn {
  padding: 0.75rem 1.5rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s;
  white-space: nowrap;
}

.copy-btn:hover:not(:disabled) {
  background: #5a67d8;
}

.copy-btn.copied {
  background: #28a745;
  animation: successPulse 0.5s ease;
}

.copy-btn:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
}

@keyframes successPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.helper-text {
  color: #718096;
  font-size: 0.875rem;
  margin: 0.5rem 0 0 0;
}

.dark .helper-text {
  color: #9ca3af;
}

.share-buttons {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
}

.share-btn {
  padding: 0.75rem 1rem;
  border: 2px solid #e5e7eb;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.share-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.share-btn.email:hover {
  border-color: #4299e1;
  color: #4299e1;
  background: #ebf8ff;
}

.share-btn.kakao:hover {
  border-color: #fee500;
  background: #fffceb;
}

.share-btn.qr:hover {
  border-color: #9f7aea;
  color: #9f7aea;
  background: #faf5ff;
}

.embed-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.embed-code {
  padding: 0.75rem;
  border: 2px solid #e5e7eb;
  border-radius: 6px;
  font-family: monospace;
  font-size: 0.875rem;
  background: #f9fafb;
  resize: none;
}

.qr-placeholder {
  padding: 3rem;
  background: #f9fafb;
  border: 2px dashed #cbd5e0;
  border-radius: 8px;
  text-align: center;
  color: #718096;
}

.share-stats {
  background: #f9fafb;
  padding: 1rem;
  border-radius: 8px;
  margin-top: 2rem;
}

.dark .share-stats {
  background: #111827;
}

.dark .share-stats h3 {
  color: #d1d5db;
}

.stats-loading {
  text-align: center;
  padding: 2rem;
  color: #6b7280;
}

.dark .stats-loading {
  color: #9ca3af;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 1rem;
}

.stat-item {
  text-align: center;
  padding: 0.75rem;
  background: white;
  border-radius: 6px;
}

.dark .stat-item {
  background: #1f2937;
}

.stat-label {
  display: block;
  color: #718096;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
}

.dark .stat-label {
  color: #9ca3af;
}

.stat-value {
  display: block;
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
}

.dark .stat-value {
  color: #f3f4f6;
}

.completion-rate {
  margin-top: 1rem;
  padding: 1rem;
  background: white;
  border-radius: 6px;
}

.dark .completion-rate {
  background: #1f2937;
}

.rate-label {
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 0.5rem;
}

.dark .rate-label {
  color: #9ca3af;
}

.rate-bar {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.dark .rate-bar {
  background: #374151;
}

.rate-fill {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #10b981);
  transition: width 0.3s ease;
}

.rate-text {
  font-size: 0.875rem;
  color: #1f2937;
  font-weight: 600;
  text-align: right;
}

.dark .rate-text {
  color: #f3f4f6;
}

.modal-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
}

.dark .modal-footer {
  border-top: 1px solid #374151;
}

.btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-secondary {
  background: #e2e8f0;
  color: #4a5568;
}

.btn-secondary:hover {
  background: #cbd5e0;
}

.dark .btn-secondary {
  background: #374151;
  color: #d1d5db;
}

.dark .btn-secondary:hover {
  background: #4b5563;
}

/* 모바일 반응형 */
@media (max-width: 640px) {
  .share-modal {
    width: 95%;
    margin: 1rem;
  }
  
  .modal-body {
    padding: 1rem;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .share-buttons {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ShareSurveyModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.share-modal {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.dark .share-modal {\n  background: #1f2937;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.dark .modal-header {\n  border-bottom: 1px solid #374151;\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 1.5rem;\n}\n\n.dark .modal-header h2 {\n  color: #f3f4f6;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #999;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s;\n}\n\n.close-btn:hover {\n  background: #f5f5f5;\n  color: #333;\n}\n\n.dark .close-btn {\n  color: #9ca3af;\n}\n\n.dark .close-btn:hover {\n  background: #374151;\n  color: #f3f4f6;\n}\n\n.modal-body {\n  padding: 1.5rem;\n}\n\n.share-section {\n  margin-bottom: 2rem;\n}\n\n.share-section h3 {\n  margin: 0 0 1rem 0;\n  color: #555;\n  font-size: 1.1rem;\n}\n\n.dark .share-section h3 {\n  color: #d1d5db;\n}\n\n.url-container {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.url-container.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.url-input {\n  flex: 1;\n  padding: 0.75rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 6px;\n  font-size: 0.95rem;\n  font-family: monospace;\n  background: #f9fafb;\n}\n\n.dark .url-input {\n  background: #111827;\n  border-color: #374151;\n  color: #f3f4f6;\n}\n\n.copy-btn {\n  padding: 0.75rem 1.5rem;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.copy-btn:hover:not(:disabled) {\n  background: #5a67d8;\n}\n\n.copy-btn.copied {\n  background: #28a745;\n  animation: successPulse 0.5s ease;\n}\n\n.copy-btn:disabled {\n  background: #cbd5e0;\n  cursor: not-allowed;\n}\n\n@keyframes successPulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n\n.helper-text {\n  color: #718096;\n  font-size: 0.875rem;\n  margin: 0.5rem 0 0 0;\n}\n\n.dark .helper-text {\n  color: #9ca3af;\n}\n\n.share-buttons {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 1rem;\n}\n\n.share-btn {\n  padding: 0.75rem 1rem;\n  border: 2px solid #e5e7eb;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.share-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.share-btn.email:hover {\n  border-color: #4299e1;\n  color: #4299e1;\n  background: #ebf8ff;\n}\n\n.share-btn.kakao:hover {\n  border-color: #fee500;\n  background: #fffceb;\n}\n\n.share-btn.qr:hover {\n  border-color: #9f7aea;\n  color: #9f7aea;\n  background: #faf5ff;\n}\n\n.embed-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.embed-code {\n  padding: 0.75rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 6px;\n  font-family: monospace;\n  font-size: 0.875rem;\n  background: #f9fafb;\n  resize: none;\n}\n\n.qr-placeholder {\n  padding: 3rem;\n  background: #f9fafb;\n  border: 2px dashed #cbd5e0;\n  border-radius: 8px;\n  text-align: center;\n  color: #718096;\n}\n\n.share-stats {\n  background: #f9fafb;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-top: 2rem;\n}\n\n.dark .share-stats {\n  background: #111827;\n}\n\n.dark .share-stats h3 {\n  color: #d1d5db;\n}\n\n.stats-loading {\n  text-align: center;\n  padding: 2rem;\n  color: #6b7280;\n}\n\n.dark .stats-loading {\n  color: #9ca3af;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.stat-item {\n  text-align: center;\n  padding: 0.75rem;\n  background: white;\n  border-radius: 6px;\n}\n\n.dark .stat-item {\n  background: #1f2937;\n}\n\n.stat-label {\n  display: block;\n  color: #718096;\n  font-size: 0.875rem;\n  margin-bottom: 0.25rem;\n}\n\n.dark .stat-label {\n  color: #9ca3af;\n}\n\n.stat-value {\n  display: block;\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.dark .stat-value {\n  color: #f3f4f6;\n}\n\n.completion-rate {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: white;\n  border-radius: 6px;\n}\n\n.dark .completion-rate {\n  background: #1f2937;\n}\n\n.rate-label {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin-bottom: 0.5rem;\n}\n\n.dark .rate-label {\n  color: #9ca3af;\n}\n\n.rate-bar {\n  width: 100%;\n  height: 8px;\n  background: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 0.5rem;\n}\n\n.dark .rate-bar {\n  background: #374151;\n}\n\n.rate-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #3b82f6, #10b981);\n  transition: width 0.3s ease;\n}\n\n.rate-text {\n  font-size: 0.875rem;\n  color: #1f2937;\n  font-weight: 600;\n  text-align: right;\n}\n\n.dark .rate-text {\n  color: #f3f4f6;\n}\n\n.modal-footer {\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.dark .modal-footer {\n  border-top: 1px solid #374151;\n}\n\n.btn {\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.btn-secondary {\n  background: #e2e8f0;\n  color: #4a5568;\n}\n\n.btn-secondary:hover {\n  background: #cbd5e0;\n}\n\n.dark .btn-secondary {\n  background: #374151;\n  color: #d1d5db;\n}\n\n.dark .btn-secondary:hover {\n  background: #4b5563;\n}\n\n/* 모바일 반응형 */\n@media (max-width: 640px) {\n  .share-modal {\n    width: 95%;\n    margin: 1rem;\n  }\n  \n  .modal-body {\n    padding: 1rem;\n  }\n  \n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .share-buttons {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
